import React, { useState, useEffect, FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles.module.scss';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { ICheckboxFilterItem } from '../../../../common/models/filter/ICheckboxFilterItem';
import CheckboxFilter from '../../../../components/CheckboxFilter';

interface ISidebarFilterProps {
  items: ICheckboxFilterItem[];
  selectFilters?: string[];
  onChange: IBindingCallback1<string[]>;
}

const SidebarFilter: FunctionComponent<ISidebarFilterProps> = (({ items, selectFilters = [], onChange }) => {
  const [selectedFilters, setSelectedFilters] = useState(selectFilters);

  const onSelect = (ids: string[]) => {
    setSelectedFilters(ids);
    onChange(ids);
  };

  useEffect(() => {
    if (!selectedFilters.length) {
      setSelectedFilters([items[0].id]);
      onChange([items[0].id]);
    }
  }, [selectedFilters]);

  return (
    <div className={styles.sidebar}>
      <div className="t-14 d-flex flex-row">
        <p className={styles.title}>
          <FormattedMessage id="candidateSidebar.filterByProgress" defaultMessage="Filter by progress" />
        </p>
      </div>
      <CheckboxFilter items={items} onChange={onSelect} selected={selectedFilters} />
    </div>
  );
});

export default SidebarFilter;
